module.exports = __webpack_public_path__ + "img/CENTRIF_HORNOS_MANIPULADOR.d8d8dab5.jpg";